var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileRtrLogoTw(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 14,
    viewBox: "0 0 47 14",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.655 4.418C10.655 1.82 8.836 0 6.237 0H0v13.566h2.547V8.784h2.65l3.171 4.782h2.86l-3.275-4.99c1.61-.571 2.702-2.287 2.702-4.158zM6.133 6.341H2.547V2.443h3.638c1.248 0 1.872 1.04 1.872 2.027 0 1.144-.728 1.871-1.924 1.871zM45.63 4.418C45.63 1.82 43.81 0 41.21 0h-6.237v13.566h2.547V8.784h2.65l3.172 4.782H46.2l-3.274-4.99c1.559-.571 2.703-2.287 2.703-4.158zm-4.523 1.923h-3.586V2.443h3.638c1.248 0 1.872 1.04 1.872 2.027 0 1.144-.728 1.871-1.924 1.871zM17.227 2.391h4.626v11.175H24.4V2.391h4.574V0H17.227v2.391z",
    fill: "#000"
  })));
}
export default SvgMobileRtrLogoTw;